import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import '../badge/index.css';
var leafNum = 3;
var Badge = (function (_super) {
    tslib_1.__extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.renderSupList = function (type) {
        var classes = "zhui-badge-leaf zhui-badge-leaf-" + type;
        var list = [];
        for (var i = 0; i < leafNum; i++) {
            list.push(React.createElement("sup", { className: classes, key: "" + type + i }));
        }
        return list;
    };
    Badge.prototype.renderContent = function (content) {
        if (typeof content === 'string') {
            return content.slice(0, 1);
        }
        return ("" + content).slice(0, 2);
    };
    Badge.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, content = _a.content;
        var classes = cn(className, 'zhui-badge');
        return (React.createElement("span", { className: classes },
            children,
            React.createElement("div", { className: "zhui-badge-wrapper" },
                this.renderSupList('outer'),
                this.renderSupList('inner'),
                React.createElement("span", { className: "zhui-badge-content" }, this.renderContent(content)))));
    };
    Badge.defaultProps = {
        className: ''
    };
    return Badge;
}(React.Component));
export default Badge;
